import type { ParsedUrlQuery } from 'querystring';

import * as local from '../storage-util/local-storage';

const STORAGE_KEY = 'checkout-return-url';

// Valid addon parameter keys that can be passed through checkout URLs
const ADDON_KEYS = [
  'events',
  'leads-catering',
  'leads-food-trucks',
  'invoice',
  'kds',
  'kiosk',
  'website',
  'online-ordering',
  'pos',
] as const;

export type AddonKey = (typeof ADDON_KEYS)[number];

/**
 * Get addon keys that are enabled in the query params
 */
export function getAddonKeys(query: ParsedUrlQuery): AddonKey[] {
  return ADDON_KEYS.filter((key) => query[key] === 'true');
}

/**
 * Save checkout return URL to localStorage for persistence through auth flow
 */
export function saveCheckoutReturnUrl(url: string): void {
  local.set(STORAGE_KEY, url);
}

/**
 * Get saved checkout return URL from localStorage
 */
export function getCheckoutReturnUrl(): string | undefined {
  return local.get<string>(STORAGE_KEY);
}

/**
 * Clear saved checkout return URL (call after successful navigation to subscriptions)
 */
export function clearCheckoutReturnUrl(): void {
  local.remove(STORAGE_KEY);
}

/**
 * Check if URL is for subscriptions page
 */
export function isSubscriptionsUrl(url: string): boolean {
  return url.includes('/account/subscriptions');
}
